import { render, staticRenderFns } from "./riseRateManager.vue?vue&type=template&id=2c6b0916&scoped=true&"
import script from "./riseRateManager.vue?vue&type=script&lang=js&"
export * from "./riseRateManager.vue?vue&type=script&lang=js&"
import style0 from "./riseRateManager.vue?vue&type=style&index=0&id=2c6b0916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b0916",
  null
  
)

export default component.exports